var _path, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u56FE\\u5C42_1",
    "data-name": "\\u56FE\\u5C42 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "02_\u7F16\u8F91") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52.18,56.1H11.62A3.72,3.72,0,0,1,7.9,52.38V11.83A3.73,3.73,0,0,1,11.62,8.1H40.09a1.85,1.85,0,0,1,0,3.7H11.62l0,40.58,40.58,0,0-28.69a1.85,1.85,0,1,1,3.69,0V52.38A3.72,3.72,0,0,1,52.18,56.1Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 39.48,
    y: 2.96,
    width: 4,
    height: 39.12,
    rx: 2,
    transform: "translate(28.07 -22.73) rotate(45)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.7b2965d4.svg";
export { ForwardRef as ReactComponent };